import { QueryErrorResetBoundaryProps, useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '~src/hooks/api/constants';
import { getScales } from './requests';
import { UseQueryLocalOptions } from '~src/config/queryClient';
import {Scale, ScalesRespI} from '~src/interfaces/scale.interface';

const useScales = (
  options?: UseQueryLocalOptions<ScalesRespI, QueryErrorResetBoundaryProps, Scale[]>,
) =>
  useQuery({
    queryKey: [QUERY_KEYS.SCALES],
    queryFn: () => getScales(),
    select: data => data.items,
    ...options,
  });

export default useScales;
